import * as yup from 'yup';
import { WizardItem } from '../Interfaces/Wizard.interface';
import { WizardItemType } from '../Enums/WizardItemType.enum';

export type BuildMultiplierArgs = {
	item: Extract<WizardItem, { type: WizardItemType.MULTIPLIER }>;
	itemSchemaShape: Record<string, yup.AnySchema>;
	t: (key: string, params?: Record<string, string>) => string | undefined;
};

const isRequired = (item: WizardItem): boolean =>
	Boolean(item.settings?.required);

export const buildMultiplierSchema = ({
	item,
	itemSchemaShape,
	t,
}: BuildMultiplierArgs): yup.AnySchema | null => {
	if (!item.key) return null;

	const errorMessage = `${t('validation.form.field')} ${t(item.title)} ${t(
		'validation.form.isRequiredToFill',
	)}`;

	let schema = yup.array().of(yup.object().shape(itemSchemaShape));

	const min = item.settings?.min;
	const max = item.settings?.max;

	if (typeof min === 'number') {
		schema = schema.min(min);
	} else if (isRequired(item)) {
		schema = schema.min(1, errorMessage);
	}

	if (typeof max === 'number') {
		schema = schema.max(max);
	}

	return isRequired(item) ? schema.required(errorMessage) : schema.nullable();
};
